"use client";
import React from "react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

const PageContent = () => {
  const t = useTranslations("tc");

  return (
    <div className="container px-5 mx-auto max-w-4xl">
      <h1 className="text-[#212121] text-[48px] font-normal leading-normal tracking-[1.92px] uppercase">
        {t("page_title")}
      </h1>
      <div className="mt-10 [&>h2]:mt-10 [&>h2]:mb-5 [&>p]:my-2.5 [&>p]:leading-8 [&>p]:tracking-[1px] [&>p>a]:underline [&>p>a]:text-[#212121]">
        <p>{t("desc")}</p>
        <h2>1. {t("title_1")}</h2>
        <p>{t("desc_1")}</p>
        <h2>2. {t("title_2")}</h2>
        <p>{t("desc_2_1")}</p>
        <p>{t("desc_2_2")}</p>
        <h2>3. {t("title_3")}</h2>
        <p>{t("desc_3")}</p>
        <h2>4. {t("title_4")}</h2>
        <p>{t("desc_4_1")}</p>
        <p>{t("desc_4_2")}</p>
        <h2>5. {t("title_5")}</h2>
        <p>{t("desc_5_1")}</p>
        <p>{t("desc_5_2")}</p>
        <p>
          {t("desc_5_3")}
          <Link href="mailto:legal@privatefleetservices.com" target="_blank">
            legal@privatefleetservices.com
          </Link>
        </p>
      </div>
    </div>
  );
};

export default PageContent;
